export default __webpack_public_path__ + "static/media/overview-nofinal.94fe8767.png";